import React from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import "./AdminRoute.css";

console.log("[MSAL] AdminRoute.js loaded");

// List of allowed admin emails
const allowedAdmins = [
  "j.sdavenport@willislawnservices.com",
  "sales@willislawnservices.com",
  "michael.ward@willislawnservices.com"
  // Add more allowed emails here
];

function clearMsalLoginFlag() {
  try {
    sessionStorage.removeItem("msalLoginInProgress");
  } catch (e) {}
}

export default function AdminRoute({ children }) {
  const { accounts, instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = accounts && accounts[0];
  const location = useLocation();

  console.log("[MSAL] AdminRoute render. inProgress:", inProgress, "accounts:", accounts, "isAuthenticated:", isAuthenticated);

  // Clear login flag after redirect handling or on authenticated
  React.useEffect(() => {
    if (inProgress === InteractionStatus.None || isAuthenticated) {
      clearMsalLoginFlag();
    }
  }, [inProgress, isAuthenticated]);

  // Wait for MSAL to finish startup/redirect handling before checking authentication
  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    console.log("[MSAL] AdminRoute waiting for MSAL to finish initializing...");
    return <div>Loading authentication...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div>
        <h2>Admin Access</h2>
        <p>You must sign in to access this page.</p>
        <button className="microsoft-signin-btn" onClick={() => {
          sessionStorage.setItem("postLoginRedirectPath", location.pathname);
          instance.loginRedirect();
        }}>
          <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="Microsoft" />
          Sign in with Microsoft
        </button>
      </div>
    );
  }

  if (!account) {
    // This should not happen if authenticated, but add a guard
    return <div>Loading account info...</div>;
  }

  if (!allowedAdmins.includes(account.username)) {
    return <div>Access Denied</div>;
  }

  // Authorized
  return children;
}
